/** Runtime environment probes — no imports from tauri/* or platform/*. */

export function isTauri(): boolean {
  return typeof window !== "undefined" && "__TAURI_INTERNALS__" in window;
}

export function joinProjectPath(rootPath: string, name: string): string {
  const sep = rootPath.includes("\\") ? "\\" : "/";
  if (rootPath.endsWith("/") || rootPath.endsWith("\\")) {
    return `${rootPath}${name}`;
  }
  return `${rootPath}${sep}${name}`;
}
